import {
  getAllLandingPagesLoading,
  getAllLandingPagesSuccess,
  getAllLandingPagesFailure,
  updateLandingPageUrlLoading,
  updateLandingPageUrlSuccess,
  updateLandingPageUrlFailure,
  createLandingPageUrlLoading,
  createLandingPageUrlSuccess,
  createLandingPageUrlFailure,
} from "@redux/slices/landingPagesSlice.js"
import { getAllLandingPages } from "@services/landingPages/getAllLandingPages.js"
import { useDispatch, useSelector } from "react-redux"
import Fuse from "fuse.js"
import { updateLandingPageUrl } from "@services/landingPages/updateLandingPageUrl"
import { createLandingPageUrl } from "@services/landingPages/createLandingPageUrl"

const useLandingPages = () => {
  const dispatch = useDispatch()
  const { landingPages } = useSelector((state) => state.landingPages) ?? {}

  const handleGetAllLandingPages = async () => {
    try {
      dispatch(getAllLandingPagesLoading())
      const response = await getAllLandingPages()
      dispatch(getAllLandingPagesSuccess(response.data.data))
    } catch (error) {
      dispatch(getAllLandingPagesFailure())
      console.log(error)
    }
  }

  const handleFuzzySearch = (searchValue) => {
    if (!searchValue || !landingPages) return []

    const fuseOptions = {
      keys: [
        { name: "url", weight: 0.7 },
      //   { name: "adId.name", weight: 0.3 },
      ],
      threshold: 0.3,
      distance: 100,
      minMatchCharLength: 2,
      ignoreLocation: true,
      shouldSort: true,
      findAllMatches: true,
    }

    const fuse = new Fuse(landingPages, fuseOptions)
    const cleanedSearch = searchValue.toLowerCase().trim()

    const directMatches = landingPages.filter(
      (page) =>
        page.url.toLowerCase().includes(cleanedSearch) ||
        page.adId?.name?.toLowerCase().includes(cleanedSearch)
    )

    const fuzzyResults = fuse.search(cleanedSearch)
    const fuzzyMatches = fuzzyResults.map((result) => result.item)

    const allResults = [...directMatches, ...fuzzyMatches]
    return [...new Set(allResults)]
  }

  const handleUpdateLandingPageUrl = async (urlId, landingPageUrl) => {
    try {
      dispatch(updateLandingPageUrlLoading())
      const response = await updateLandingPageUrl(urlId, landingPageUrl)
      dispatch(updateLandingPageUrlSuccess(response.data.data))
    } catch (error) {
      dispatch(updateLandingPageUrlFailure())
      console.error("Error updating landing page URL:", error)
    }
  }

  const handleCreateLandingPageUrl = async (data) => {
    try {
      dispatch(createLandingPageUrlLoading())
      const response = await createLandingPageUrl(data)
      dispatch(createLandingPageUrlSuccess(response.data))
    } catch (error) {
      dispatch(createLandingPageUrlFailure())
      console.error("Error creating landing page URL:", error)
    }
  }

  return {
    handleGetAllLandingPages,
    handleFuzzySearch,
    handleUpdateLandingPageUrl,
    handleCreateLandingPageUrl,
  }
}

export default useLandingPages
